import React from "react";
import { Landmark, Scale, Coins, Layers, Building2, TrendingUp, Infinity as InfinityIcon, ChevronDown } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const NODES = [
  { icon: Landmark, label: "Acharya Holdings", note: "The permanent institutional platform.", top: true },
  { icon: Scale, label: "Governance", note: "Ethics, compliance, and decision frameworks." },
  { icon: Coins, label: "Capital", note: "Disciplined allocation and financial oversight." },
  { icon: Layers, label: "Shared Services", note: "Standards, systems, and operational support." },
  { icon: Building2, label: "Operating Companies", note: "Independent ventures with clear mandates." },
  { icon: TrendingUp, label: "Independent Growth", note: "Each venture scales on its own terms." },
  { icon: InfinityIcon, label: "Long-term Value Creation", note: "Stewardship and continuity across decades." },
];

export const GroupStructureDiagram = () => {
  return (
    <div data-testid="group-structure-diagram" className="mx-auto max-w-[560px]">
      {NODES.map((n, i) => {
        const Icon = n.icon;
        return (
          <div key={n.label}>
            <Reveal delay={i * 0.04}>
              <div
                className="flex items-center gap-5 rounded-[16px] px-6 py-5 transition-colors duration-300"
                style={{
                  background: n.top ? "linear-gradient(180deg, rgba(140,106,61,0.10), rgba(140,106,61,0.02))" : "var(--surface)",
                  border: `1px solid ${n.top ? "rgba(140,106,61,0.4)" : "var(--card-border)"}`,
                }}
              >
                <span
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full"
                  style={{ background: "rgba(140,106,61,0.10)", border: "1px solid rgba(140,106,61,0.35)" }}
                >
                  <Icon size={19} strokeWidth={1.6} style={{ color: "var(--accent)" }} />
                </span>
                <div className="min-w-0">
                  <p className="text-[16px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.2px" }}>{n.label}</p>
                  <p className="mt-0.5 text-[13px] leading-[1.6]" style={{ color: "var(--muted)" }}>{n.note}</p>
                </div>
              </div>
            </Reveal>

            {i < NODES.length - 1 && (
              <div className="flex flex-col items-center py-2.5" aria-hidden="true">
                <span className="h-5 w-px" style={{ background: "linear-gradient(180deg, rgba(140,106,61,0.5), rgba(140,106,61,0.15))" }} />
                <ChevronDown size={15} style={{ color: "var(--accent)", opacity: 0.7, marginTop: -2 }} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
